import React, { useContext } from 'react';

import './StartButton.scss'
import './Adaptations.scss'

import { Link } from 'react-router-dom';
import { MainContext } from "../../contexts/MainContext";

export default function StartButton({title, link}){

  const {
      setSelectComActive,
      setSelectProActive,
  } = useContext(MainContext);

  return (
    <>
      <Link
       to={link} 
       className="start-button-wrapper"
       onClick={() => {
        setSelectComActive(false);
        setSelectProActive(false);
       }}
      >
        <span>{title}</span>
      </Link>
    </>
  );
};
